module.exports = __webpack_public_path__ + "img/signature.16b5d34b.jpg";